import { LINES } from './lines';

/*
 * The whole system as scenery behind the gate's title: thirteen lines leave
 * Central Station side by side and fan out, one per genre, with trains running
 * on them. It is what the gate promises, drawn before there is a list to draw
 * it from, so it shows every line; the hub later shows only the ones a rider's
 * list actually runs. It carries no labels: the words in front of it do the
 * telling.
 *
 * Geometry is octilinear like a real metro map: each line runs out of the
 * interchange in a bundle, turns 45° once to reach its own row, and runs level
 * from there, with rounded corners at both turns.
 */

const CY = 300; // the bundle's centre row
const HUB_X = 112; // the interchange
const BEND_X = 176; // where the bundle starts to fan out
const END_X = 492; // where the lines end
const PITCH = 13; // line spacing inside the bundle
const TERM_PITCH = 40; // line spacing once fanned out
const T = 11; // a rounded corner starts this far before its bend
const D = T / Math.SQRT2;

const n = (v: number) => Math.round(v * 10) / 10;

function route(i: number) {
  const k = i - (LINES.length - 1) / 2;
  const y0 = CY + k * PITCH;
  const y1 = CY + k * TERM_PITCH;
  const rise = Math.abs(y1 - y0);
  const s = Math.sign(y1 - y0);
  const level = BEND_X + rise; // where the diagonal reaches the line's row
  return rise === 0
    ? `M${HUB_X} ${y0}H${END_X}`
    : `M${HUB_X} ${n(y0)}H${BEND_X - T}Q${BEND_X} ${n(y0)} ${n(BEND_X + D)} ${n(y0 + s * D)}` +
        `L${n(level - D)} ${n(y1 - s * D)}Q${n(level)} ${n(y1)} ${n(level + T)} ${n(y1)}H${END_X}`;
}

const ROUTES = LINES.map((line, i) => ({ line, i, d: route(i) }));

export function RouteMap({ busy = false }: { busy?: boolean }) {
  return (
    <figure className={`routemap${busy ? ' busy' : ''}`} aria-hidden="true">
      {/* framed on the lines, so the figure's centre is the network's */}
      <svg viewBox="-18 34 640 540">
        {/* The group carries the busy pulse and the path its draw-in, so ending
            the pulse cannot restart the draw. */}
        {ROUTES.map(({ line, i, d }) => (
          <g
            key={line.slug}
            className="lnw"
            style={{ ['--c' as string]: line.color, ['--i' as string]: i }}
          >
            <path className="ln" d={d} pathLength={1} />
          </g>
        ))}

        {ROUTES.map(({ line, i, d }) => (
          <g key={line.slug} className="train" style={{ ['--c' as string]: line.color }}>
            <rect x="-9" y="-4" width="18" height="8" rx="4" />
            <animateMotion
              path={d}
              rotate="auto"
              dur={`${11 + (i % 4) * 2.3}s`}
              begin={`${-n((i * 1.7) % 9)}s`}
              repeatCount="indefinite"
              calcMode="linear"
              keyPoints="0;1;1;0;0"
              keyTimes="0;0.44;0.5;0.94;1"
            />
          </g>
        ))}
      </svg>
    </figure>
  );
}
